import EA from '../helpers/init';

export default EA.Methods.modalHandler = ($this) => {
    const modalTriggers = document.querySelectorAll('[data-modal]');


    function closeCurrentlyActiveModal() {
        document.body.style.overflow = 'auto';

        const activeModal = $this.querySelector('.modal.active');

        if (activeModal) {
            $this.classList.remove('active');
            activeModal.classList.remove('active');

            setTimeout(() => {
                $this.style.visibility = 'hidden';
            }, 420);
        }
    }

    function openModal(modal) {
        if (!modal) return;

        const closeButton = modal.querySelector('.modal-close');

        document.body.style.overflow = 'hidden';
        $this.classList.add('active');
        $this.style.visibility = 'visible';
        modal.classList.add('active');

        closeButton.addEventListener('click', () => {
            closeCurrentlyActiveModal();
        }, { once: true });
    }

    // Setup modal trigger click handling
    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            const modal = $this.querySelector(`.${trigger.getAttribute('data-modal')}`);
            openModal(modal);
        });
    });

    // Setup esc key modal closing
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeCurrentlyActiveModal();
        }
    });

    // Setup overlay click modal closing
    $this.addEventListener('click', (event) => {
        if ((event.target === $this) && $this.classList.contains('active')) {
            closeCurrentlyActiveModal();
        }
    });


    // Newsletter modal logic
    const NEWSLETTER_DISMISSED_COOKIE = 'newsletter_dismissed';
    const NEWSLETTER_SUBMITTED_COOKIE  = 'newsletter_submitted';

    function getCookie(name) {
        return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1] ?? null;
    }

    function setCookie(name, value, days) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
    }


    // Newsletter Modal
    const newsletterModal = $this.querySelector('[data-modal-newsletter]');

    if(newsletterModal) {
        const alreadySubmitted = getCookie(NEWSLETTER_SUBMITTED_COOKIE);
        const recentlyDismissed = getCookie(NEWSLETTER_DISMISSED_COOKIE);

        if(!alreadySubmitted && !recentlyDismissed) {
            setTimeout(() => {
                openModal(newsletterModal);
            }, 30000);

            newsletterModal.querySelector('.modal-close').addEventListener('click', () => {
                setCookie(NEWSLETTER_DISMISSED_COOKIE, 'true', 30);
            }, { once: true });

            document.addEventListener('keydown', (event) => {
                if(event.key === 'Escape') {
                    setCookie(NEWSLETTER_DISMISSED_COOKIE, 'true', 30);
                }
            }, { once: true });

            const form = newsletterModal.querySelector('form');
            form.addEventListener('submit', () => {
                setCookie(NEWSLETTER_SUBMITTED_COOKIE, 'true', 365);
            }, { once: true });
        }
    }
};
